












import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class IconRemove extends Vue {
    @Prop({ default: false, type: Boolean }) noOutline!: boolean
}
